import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError, ECreativeStatus } from '@unfoldrtech/portal-mic'
import {
  EReportingTimeWindow,
  ETimeBucketType,
  IReportingCreativesChartResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAAdGroupsCreativesReportChartFilters,
  TDACreativesReportChartFilters,
  TDOOHAdGroupsCreativesReportChartFilters,
  TDOOHCreativesReportChartFilters,
  TPPRetailerId,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetRetailerReportingCreativesChartV3({
  retailerId,
  advertiserId,
  inventoryType,
  campaignId,
  adGroupId,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}:
  | {
      enabled?: boolean
      suspense?: boolean
    } & (
      | TDACreativesReportChartFilters
      | TDAAdGroupsCreativesReportChartFilters
      | TDOOHCreativesReportChartFilters
      | TDOOHAdGroupsCreativesReportChartFilters
    ) &
      TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingCreativesChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingCreativesChart_${retailerId}_${advertiserId}`

  return useQuery(
    [
      queryKeyName,
      { start: startDate, end: endDate, campaignId, inventoryType },
    ],
    () => {
      return coreAPIV3.retailerReporting().getRetailerCreativesReportChartV3(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        campaignId,
        adGroupId,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        aggregationType as ETimeBucketType,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status as ECreativeStatus
      )
    },
    { suspense, enabled }
  )
}
